import Paper from "@mui/material/Paper";
import FormFader from "@/src/components/Form/Common/Fader/FormFader";
import React from "react";
import FormSubmit from "@/src/components/Form/Common/FormSubmit/FormSubmit";
import AlimonyChild from "./AlimonyChild/AlimonyChild";
import { useForm } from "@/src/provider/Form/FormProvider";
import Typography from "@mui/material/Typography";
import FormSubmitProps from "@/src/types/FormSubmitProps";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { Child } from "@/src/types/Entities/Child";
import wizardStyle from "@/src/components/Form/wizardStyle";
import { Box } from "@mui/material";

type AlimonyChildrenProps = { submitProps: FormSubmitProps; product: AbstractCase };
export default function AlimonyChildren({ submitProps, product }: AlimonyChildrenProps) {
  const { handleSubmit } = useForm();
  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm }} onSubmit={handleSubmit}>
          <Typography variant={"h5"} sx={wizardStyle.headline}>
            {`Angaben zu ${product.numberOfChildren > 1 ? "den Kindern" : "dem Kind"}`}
          </Typography>
          {product.children.map((child: Child, index: number) => (
            <AlimonyChild key={index} childIndex={index} />
          ))}
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
